export default __webpack_public_path__ + "static/media/apple_button.6852ca44.webp";